<template>
  <div :class="$style.symbol">{{symbol}}{{symbol}}{{symbol}}</div>
</template>

<script>
import LocaleCurrency from 'locale-currency';
import getSymbolForCurrency from 'currency-symbol-map';

export default {
  name: 'CurrencySymbol',

  computed: {
    symbol() {
      const language = window.navigator.language;
      const currency = LocaleCurrency.getCurrency(language);
      const symbol = getSymbolForCurrency(currency);

      if (!symbol) {
        return '$';
      }

      return symbol;
    },
  },
};
</script>

<style lang="scss" module>
.symbol {
  display: inline-block;
  font-size: 70px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/CurrencySymbol.vue